interface Props {
    className?: string
    FillColor?: string
}

export default function Heart({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
            <path
                d="M3.85123 5.34487C5.96913 3.21838 9.39087 3.21838 11.5088 5.34487L12 5.83809L12.4912 5.34487C14.6091 3.21838 18.0309 3.21838 20.1488 5.34487C22.2837 7.48849 22.2837 10.9776 20.1488 13.1213L12.5195 20.7814C12.2293 21.0729 11.7707 21.0729 11.4805 20.7814L3.85123 13.1213C1.71626 10.9776 1.71626 7.48849 3.85123 5.34487ZM10.4697 6.47591C8.93235 4.93227 6.42765 4.93227 4.89025 6.47591C3.36992 8.0024 3.36992 10.4637 4.89025 11.9902L12 19.1288L19.1097 11.9902C20.6301 10.4637 20.6301 8.0024 19.1097 6.47591C17.5723 4.93227 15.0677 4.93227 13.5303 6.47591C13.5303 6.47591 12.8098 7.19932 12.5195 7.49074C12.2293 7.78217 11.7707 7.78217 11.4805 7.49074C11.1902 7.19932 10.4697 6.47591 10.4697 6.47591Z"
                fill={FillColor}/>
        </svg>
    )
}
